import EducationModeList from './EducationModeList';

export default EducationModeList; 